module.exports = __webpack_public_path__ + "static/media/ussf90mintext-medium.8c72b9e9.woff";